const LINES = [
  "Pennylane en lecture seule.",
  "Des relances à votre nom.",
  "L’historique reste sur le client.",
];

/** Trois repères produit, lisibles immédiatement et sans animation décorative. */
export function ThreadBand() {
  return (
    <section aria-label="Nos engagements" className="bg-primary text-primary-foreground">
      <ul className="mx-auto grid max-w-[1200px] gap-5 px-4 py-9 sm:px-6 md:grid-cols-3 md:gap-8 lg:px-8 lg:py-11">
        {LINES.map((line) => (
          <li key={line} className="border-l border-primary-foreground/30 pl-4 text-base leading-relaxed font-medium lg:text-lg">{line}</li>
        ))}
      </ul>
    </section>
  );
}
